// Leading element of a message-list row; persisted to OCS `mail_personacheckboxdisplay`.
export enum PersonaCheckboxDisplayOption {
    ShowSenderImage = 0,
    ShowCheckboxOnly = 1,
    ShowNameOnly = 2,
}

// Rejects stale/corrupt persisted values outside the enum
export function isValidPersonaCheckboxDisplayOption(
    value: unknown
): value is PersonaCheckboxDisplayOption {
    return (
        value === PersonaCheckboxDisplayOption.ShowSenderImage ||
        value === PersonaCheckboxDisplayOption.ShowCheckboxOnly ||
        value === PersonaCheckboxDisplayOption.ShowNameOnly
    );
}
